
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function TrustSection() {
  const { ref, isVisible } = useScrollReveal(0.2);

  return (
    <section className="py-32 md:py-40 bg-[#0B0D10] relative overflow-hidden">
      <div ref={ref} className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className={`relative w-full h-[440px] rounded-2xl overflow-hidden transition-all duration-1000 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
            <img
              src="https://public.readdy.ai/ai/img_res/13df30235fd377766a2ff14ccca79a67.jpg"
              alt="Executive boardroom"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0B0D10]/40 to-transparent"></div>
          </div>

          <div className={`transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <p className="text-sm tracking-[0.25em] uppercase text-[#3A5F8C] mb-6 font-medium">Trust</p>
            <h2 className="text-4xl md:text-5xl font-bold text-[#F5F7FA] tracking-tight leading-[1.1] mb-8">
              Designed for Serious Organizations
            </h2>

            <p className="text-lg text-[#F5F7FA]/60 leading-relaxed mb-6">
              We partner with executive teams who demand rigor, clarity, and accountability.
            </p>

            <p className="text-lg text-[#C9CDD3] font-medium leading-relaxed">
              If your organization requires structure, discipline, and results — we are aligned.
            </p>

            <div className="mt-10 flex items-center gap-8">
              <div className="text-center">
                <p className="text-3xl font-bold text-[#F5F7FA]">150+</p>
                <p className="text-xs text-[#F5F7FA]/40 mt-1 uppercase tracking-wider">Audits Completed</p>
              </div>
              <div className="w-px h-12 bg-[#2A2E35]"></div>
              <div className="text-center">
                <p className="text-3xl font-bold text-[#F5F7FA]">$2.4B</p>
                <p className="text-xs text-[#F5F7FA]/40 mt-1 uppercase tracking-wider">Value Impacted</p>
              </div>
              <div className="w-px h-12 bg-[#2A2E35]"></div>
              <div className="text-center">
                <p className="text-3xl font-bold text-[#F5F7FA]">98%</p>
                <p className="text-xs text-[#F5F7FA]/40 mt-1 uppercase tracking-wider">Client Satisfaction</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
